import './styles.styl'
import 'antd/dist/antd.css'
import React from 'react'

import {
  Menu,
  Dropdown,
  Icon,
  Button
} from 'antd'

export default class ListProjects extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      filter: 'production',
      sort: ['name', 'asc'],
    }
  }

  componentWillMount () {
    if (this.props.fetched === false && this.props.fetching === false) {
      this.props.loadProjects()
    }

    if (this.props.customersFetched === false && this.props.customersFetching === false) {
      this.props.loadCustomers()
    }

    let search = window.location.search

    if (typeof search === 'string' && search.startsWith('?status=')) {
      search = search.replace('?status=', '').trim()
      search = search === '' ? 'production' : search
      this.setState({
        filter: search
      })
    }
  }

  createUntitledProject () {
    if (!Array.isArray(this.props.customers) || this.props.customers.length === 0) {
      return
    }

    this.props.createProject('Untitled', this.props.customers[0].id).then(project => {
      this.props.navigateTo(`/projects/edit/${project.id}`)
    })
  }

  deleteProject (projectId) {
    if (!window.confirm('Weet u het zeker? Deze actie kan niet ongedaan worden gemaakt.')) {
      return
    }

    this.props
      .updateProject(projectId, { destroyed: true })
      .catch(err => {
        console.log(`Error destroying project: ${err.message}`)
        return {}
      })
      .then(() => this.props.navigateTo(`/projects?status=beta`))
  }

  render () {
    const {
      fetched,
      fetching,
      list
    } = this.props

    const {
      filter,
      sort,
    } = this.state

    let content = null

    if (fetched === false) {
      content = (
        <div className='alert alert-primary'>
          <strong>Geen data...</strong><br />
          <a onClick={() => this.props.loadProjects()}>Klik hier</a> om het opnieuw te proberen.
        </div>
      )
    }

    if (fetching === true) {
      content = (
        <div className='alert alert-primary'>
          <strong>Momentje...</strong><br />
          We halen de projectdata op.
        </div>
      )
    }

    if (fetched === true) {
      const rows = list
        .filter(project => {
          if (filter === 'production' && (!project.status || !project.hasOwnProperty('status'))) {
            return true
          }

          if (project.status && project.status === filter) {
            return true
          }

          return false
        })
        .sort((a, b) => {
          const [ sortKey, direction ] = sort;

          if (sortKey === 'id') {
            return direction === 'asc' ? a.id - b.id : b.id - a.id
          }

          if (sortKey === 'name') {
            return direction === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
          }

          if (sortKey === 'fqdn') {
            let domainNameA = ''
            let domainNameB = ''

            if (Object.isObject(a, 'settings') && Object.isObject(a.settings, 'basicSettings')) {
              domainNameA = a.settings.basicSettings.domainName
            }

            if (Object.isObject(b, 'settings') && Object.isObject(b.settings, 'basicSettings')) {
              domainNameB = b.settings.basicSettings.domainName
            }

            return direction === 'asc' ? domainNameA.localeCompare(domainNameB) : domainNameB.localeCompare(domainNameA)
          }
        })
        .map((customer, index) => {
          let dropdown = null
          let maintenanceAction = null

          if (customer && customer.settings && typeof customer.settings === 'object' && customer.settings.hasOwnProperty('basicSettings') && typeof customer.settings.basicSettings === 'object') {
            const { settings } = customer;
            const { basicSettings } = settings;

            if (basicSettings.maintenanceMode === true) {
              maintenanceAction = (
                <Menu.Item key='4' onClick={() => this.setMaintenanceMode(customer, false)}><Icon type='tool' />Onderhoudsmodus uit</Menu.Item>
              )
            } else {
              maintenanceAction = (
                <Menu.Item key='4' onClick={() => this.setMaintenanceMode(customer, true)}><Icon type='tool' />Onderhoudsmodus aan</Menu.Item>
              )
            } 
          }

          if (!customer.hasOwnProperty('status') || !customer.status || customer.status === 'production') {
            dropdown = (
              <Menu>
                <Menu.Item key='1' onClick={() => this.props.navigateTo(`/projects/edit/${customer.id}`)}><Icon type='edit' />Bewerken</Menu.Item>
                <Menu.Item key='2' onClick={this.copyToBeta(customer.id)}><Icon type='copy' />Kopieer naar beta</Menu.Item>
                <Menu.Item key='3' onClick={this.setStatus(customer.id, 'hidden')}><Icon type='eye-invisible' />Verbergen</Menu.Item>
                {maintenanceAction}
              </Menu>
            )
          }

          if (customer.status === 'beta') {
            dropdown = (
              <Menu>
                <Menu.Item key='1' onClick={() => this.props.navigateTo(`/projects/edit/${customer.id}`)}><Icon type='edit' />Bewerken</Menu.Item>
                <Menu.Item key='3' onClick={() => this.deleteProject(customer.id)}><Icon type='delete' />Verwijder</Menu.Item>
                <Menu.Item key='2' onClick={this.setLive(customer.id)}><Icon type='copy' />Zet live</Menu.Item>
                {maintenanceAction}
              </Menu>
            )
          }

          let domainName = ''

          if (Object.isObject(customer, 'settings') && Object.isObject(customer.settings, 'basicSettings')) {
            domainName = customer.settings.basicSettings.domainName
          }

          return (
            <tr key={index}>
              {/* <td>{index + 1}</td> */}
              <td><code>{customer.id}</code></td>
              <td>{customer.name}</td>
              <td>
                <code>{domainName}</code>
              </td>
              <td>
                {customer.status !== 'hidden' && (<Dropdown overlay={dropdown} trigger={[ 'click' ]}>
                  <Button style={{ marginLeft: 8 }}>
                    Acties <Icon type='down' />
                  </Button>
                </Dropdown>)}

                {customer.status === 'hidden' && (<Button onClick={this.setStatus(customer.id, 'production')}>
                  <Icon type='eye' /> Maak zichtbaar
                </Button>)}
              </td>
            </tr>
          )
        })
      content = (
        <div className='page-inner'>
          <table className='table' cellPadding='0' cellSpacing='0'>
            <thead>
              <tr>
                {/* <th width={40}>#</th> */}
                <th className={sort[0] !== 'id' ? '' : `sort-${sort[1]}`} onClick={this.setSort('id')} width={250}>ID</th>
                <th className={sort[0] !== 'name' ? '' : `sort-${sort[1]}`} onClick={this.setSort('name')}>Naam</th>
                <th className={sort[0] !== 'fqdn' ? '' : `sort-${sort[1]}`} onClick={this.setSort('fqdn')}>FQDN</th>
                <th width={100} />
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </table>
        </div>
      )
    }

    return (
      <div className='page'>
        <header className='header'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12 col-sm-6'>
                <h1>Projecten</h1>
              </div>
              {filter === 'beta' && (<div className='col-12 col-sm-6 text-align-right'>
                <button type='button' className='btn btn-success btn-rounded btn-add' onClick={() => this.createUntitledProject()}><i className='fa fa-plus' /> Nieuw project</button>
              </div>)}
            </div>
            <div className='row'>
              <div className='col-12 col-sm-8'>
                <ul className='nav nav-tabs'>
                  <li className='nav-item'>
                    <a className={`nav-link ${filter === 'production' ? 'active' : ''}`} onClick={() => this.setState({ filter: 'production' })}>Productie</a>
                  </li>
                  <li className='nav-item'>
                    <a className={`nav-link ${filter === 'beta' ? 'active' : ''}`} onClick={() => this.setState({ filter: 'beta' })}>Beta</a>
                  </li>
                  <li className='nav-item'>
                    <a className={`nav-link ${filter === 'hidden' ? 'active' : ''}`} onClick={() => this.setState({ filter: 'hidden' })}>Verborgen</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </header>

        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              {content}
            </div>
          </div>
        </div>
      </div>
    )
  }

  setLive (id) {
    return () => {
      if (!window.confirm('Weet u het zeker? Dit kopieert alle gemaakte instellingen naar "productie" en verwijderd het beta project.')) {
        return
      }

      this.props.setLive(id)
      this.setState({ filter: 'production' })
    }
  }

  setMaintenanceMode (project, state) {
    this.props.setMaintenanceMode(project, state)
  }

  copyToBeta (id) {
    return () => {
      this.props.copyToBeta(id)
      this.setState({ filter: 'beta' })
    }
  }

  setStatus (id, status) {
    return () => {
      if (!window.confirm('Weet u zeker dat u de zichtbaarheid van dit project aan wil passen?')) {
        return
      }

      this.props.setProjectStatus(id, status)
      this.setState({ filter: status })
    }
  }

  setSort (newSort) {
    return () => {
      const { sort } = this.state;
      this.setState({
        sort: [
          newSort,
          sort[0] === newSort && sort[1] === 'asc' ? 'desc' : 'asc'
        ]
      })
    }
  }
}



// WEBPACK FOOTER //
// ./ui/projects/list/component.js